import { apiClient } from '@/core/infra_api_client'

// ============= Types =============

export type UpdateStatus = 'available' | 'downloading' | 'applying' | 'applied' | 'failed'
export type UpdateSeverity = 'critical' | 'high' | 'medium' | 'low'

export interface AvailableUpdate {
  id: string
  name: string
  version: string
  currentVersion: string
  severity: UpdateSeverity
  status: UpdateStatus
  releaseNotes?: string
  publishedAt: string
  componentType: string
}

export interface UpdateDetail {
  id: string
  name: string
  version: string
  currentVersion: string
  severity: UpdateSeverity
  status: UpdateStatus
  releaseNotes?: string
  changelog: string[]
  dependencies: string[]
  publishedAt: string
  componentType: string
  estimatedDowntime?: string
}

export interface ApplyUpdateRequest {
  scheduledAt?: string
  force?: boolean
}

export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  perPage: number
  totalPages: number
}

// ============= API =============

const BASE_PATH = 'updates'

export async function listUpdates(params?: {
  page?: number
  perPage?: number
  status?: string
  severity?: string
}): Promise<PaginatedResponse<AvailableUpdate>> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.page) searchParams['page'] = params.page
  if (params?.perPage) searchParams['per_page'] = params.perPage
  if (params?.status) searchParams['status'] = params.status
  if (params?.severity) searchParams['severity'] = params.severity

  return apiClient.get<PaginatedResponse<AvailableUpdate>>(BASE_PATH, searchParams)
}

export async function getDetail(id: string): Promise<UpdateDetail> {
  return apiClient.get<UpdateDetail>(`${BASE_PATH}/${id}`)
}

export async function applyUpdate(id: string, data?: ApplyUpdateRequest): Promise<AvailableUpdate> {
  return apiClient.post<AvailableUpdate, ApplyUpdateRequest>(`${BASE_PATH}/${id}/apply`, data)
}
